import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";
import Icon from "../../Utils/Icon";
import Loader from "../../Utils/Loader";

function AntiFraudFilters({onApplyFilters, reference, isLoading}) {
    const [selectedSources, setSelectedSources] = useState([]);
    const [selectedKinds, setSelectedKinds] = useState([]);
    const [isBlocked, setIsBlocked] = useState(null);

    function handleSourceChange(code, checked) {
        if (checked) {
            setSelectedSources([...selectedSources, code]);
        } else {
            setSelectedSources(selectedSources.filter((s) => s !== code));
        }
    }

    function handleKindChange(code, checked) {
        if (checked) {
            setSelectedKinds([...selectedKinds, code]);
        } else {
            setSelectedKinds(selectedKinds.filter((k) => k !== code));
        }
    }

    function handleApply() {
        const filters = [];

        selectedSources.forEach((source) => {
            filters.push({key: "source", value: source});
        });

        selectedKinds.forEach((kind) => {
            filters.push({key: "kind", value: kind});
        });

        if (isBlocked !== null) {
            filters.push({key: "isBlocked", value: isBlocked ? "true" : "false"});
        }

        onApplyFilters(filters);
    }

    function handleReset() {
        setSelectedSources([]);
        setSelectedKinds([]);
        setIsBlocked(null);
        onApplyFilters([]);
    }

    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                {/* Sources */}
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="AntiFraudFilters.title.source" defaultMessage="Источник"/>
                    </h6>
                    <div className={classes.Column}>
                        {(reference.sources || []).map((source) => (
                            <div className={classes.CheckboxWrap} key={source.value}>
                                <input
                                    id={`source-${source.value}`}
                                    type="checkbox"
                                    checked={selectedSources.includes(source.value)}
                                    onChange={(e) => handleSourceChange(source.value, e.target.checked)}
                                />
                                <label htmlFor={`source-${source.value}`} className={classes.CustomCheckbox}>
                                    <span>{source.label}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Kinds */}
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="AntiFraudFilters.title.kind" defaultMessage="Тип данных"/>
                    </h6>
                    <div className={classes.Column}>
                        {(reference.kinds || []).map((kind) => (
                            <div className={classes.CheckboxWrap} key={kind.value}>
                                <input
                                    id={`kind-${kind.value}`}
                                    type="checkbox"
                                    checked={selectedKinds.includes(kind.value)}
                                    onChange={(e) => handleKindChange(kind.value, e.target.checked)}
                                />
                                <label htmlFor={`kind-${kind.value}`} className={classes.CustomCheckbox}>
                                    <span>{kind.label}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Status */}
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="AntiFraudFilters.title.status" defaultMessage="Статус"/>
                    </h6>
                    <div className={classes.Column}>
                        <div className={classes.CheckboxWrap}>
                            <input
                                id="status-blocked"
                                type="checkbox"
                                checked={isBlocked === true}
                                onChange={(e) => setIsBlocked(e.target.checked ? true : null)}
                            />
                            <label htmlFor="status-blocked" className={classes.CustomCheckbox}>
                                <div className={classes.BlockIcon}/>
                                <span>
                                    <FormattedMessage id="AntiFraudFilters.status.blocked"
                                                      defaultMessage="Заблокирован"/>
                                </span>
                            </label>
                        </div>
                        <div className={classes.CheckboxWrap}>
                            <input
                                id="status-unblocked"
                                type="checkbox"
                                checked={isBlocked === false}
                                onChange={(e) => setIsBlocked(e.target.checked ? false : null)}
                            />
                            <label htmlFor="status-unblocked" className={classes.CustomCheckbox}>
                                <div className={classes.ActiveIcon}/>
                                <span>
                                    <FormattedMessage id="AntiFraudFilters.status.unblocked"
                                                      defaultMessage="Разблокирован"/>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <button onClick={handleApply} className={classes.Submit} disabled={isLoading}>
                    {!isLoading ? (
                        <Icon className={classes.buttonIcon} icon="filter" size="17px"/>
                    ) : (
                        <Loader isString={true}/>
                    )}
                    <FormattedMessage id="AntiFraudFilters.btn.filter" defaultMessage="Фильтровать"/>
                </button>
                <button onClick={handleReset} className={classes.Reset}>
                    <FormattedMessage id="AntiFraudFilters.btn.reset" defaultMessage="Сбросить"/>
                </button>
            </div>
        </div>
    );
}

AntiFraudFilters.defaultProps = {
    reference: {sources: [], kinds: []},
    isLoading: false,
    onApplyFilters: () => {
    },
};

export default AntiFraudFilters;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AntiFraudFilters/index.js